var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-coe-scroll", style: _vm.styles }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasScroll && _vm.active,
            expression: "hasScroll && active"
          }
        ],
        staticClass: "scrollbar-wrapper"
      },
      [
        _c("div", {
          staticClass: "full-scrollbar",
          style: {
            opacity: +_vm.showScroll,
            width: _vm.fullScrollbarWidth + "px"
          },
          on: {
            mouseout: _vm.hide,
            mouseover: _vm.show,
            mousedown: _vm.onClick
          }
        }),
        _vm._v(" "),
        _c("div", {
          ref: "scrollbar",
          staticClass: "scrollbar",
          style: {
            opacity: +_vm.showScroll,
            width: _vm.scrollbarWidth + "px",
            height: _vm.scrollbarHeight + "px"
          },
          on: { mouseout: _vm.hide, mouseover: _vm.show }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      _vm._g({ ref: "wrapper", staticClass: "wrapper" }, _vm.$listeners),
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }